import { useEffect } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { BannerResponse } from "@/api";
import { QueryKey } from "@/query/Query";

export function useRefetchAtNextBannerTransition(banner: BannerResponse | null | undefined) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!banner) {
      return;
    }

    const delay = getMsUntilNextBannerTransition(banner);
    if (delay == null) {
      return;
    }

    const timer = setTimeout(
      () => void queryClient.invalidateQueries({ queryKey: [QueryKey.MaintenanceBanner] }),
      delay
    );
    return () => clearTimeout(timer);
  }, [banner, queryClient]);
}

/** Returns the milliseconds until the next banner phase transition (banner start or maintenance start(which is same as banner end)), or null if no future transition remains. */
function getMsUntilNextBannerTransition(banner: BannerResponse): number | null {
  const bannerStart = banner.bannerStartUtc.getTime();
  const maintenanceStart = banner.maintenanceStartUtc.getTime();
  const currentTime = Date.now();

  const nextTransition = bannerStart > currentTime ? bannerStart : maintenanceStart;
  const delay = nextTransition - currentTime;

  return delay > 0 ? delay : null;
}
